import React from "react";
import "./index.css";
import AppRouter from "./AppRouter";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")).render(<AppRouter />);
